import useMediaQuery from '@mui/material/useMediaQuery';

export function useIsWidthUp(breakpoint) {
  return useMediaQuery((theme) => theme.breakpoints.up(breakpoint));
}
export function useIsWidthDown(breakpoint) {
  return useMediaQuery((theme) => theme.breakpoints.down(breakpoint));
}
